<template>
    <div class="p-5 flex flex-col space-y-10">
        <div class="flex flex-col bg-white my-20 max-w-7xl mx-auto">
            <div class="mx-16 2xl:mx-0">
                <div class="w-full h-full bg-white flex items-center">
                    <div v-for="i in intro" class="h-full w-1/2 flex flex-col justify-center">
                        <EditableProposalText :title="i.title" />
                        <EditableProposalText :text="i.text" :showMoreText="true" />
                    </div>
                    <div v-if="header_image !== null">
                        <figure v-if="header_image.mime_type.includes('image/')" class="aspect-w-16 aspect-h-9 w-full">
                            <img
                                class="object-cover"
                                :src="header_image.original_url"
                                :alt="header_image.name"
                            >
                        </figure>
                        <div v-else class="flex flex-col justify-center items-center pointer-events-none bg-indigo-100 text-indigo-700 object-cover group-hover:opacity-75">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-12 h-12">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                            </svg>
                            <span>Unknown media type</span>
                        </div>
                    </div>
                    <div class="w-1/2 flex flex-col justify-center items-center bg-gray-100">
                        <svg v-if="loading_gallery_images"
                             class="w-20 h-20 m-20 text-gray-200 animate-spin dark:text-gray fill-blue"
                             viewBox="0 0 100 101"
                             xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor"
                            />
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill"
                            />
                        </svg>
                        <template v-else>
                            <ul role="list" class="grid w-full grid-cols-1 gap-x-4 gap-y-4 sm:grid-cols-2 lg:grid-cols-3">
                                <li @click="editMedia(file)" v-for="file in gallery_images" :key="file.id" class="relative">
                                    <div
                                        class="group relative aspect-w-10 aspect-h-7 block w-full overflow-hidden rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 border border-2 border-transparent hover:border-primary"
                                    >
                                        <img :src="file.original_url" alt="" class="pointer-events-none object-cover group-hover:opacity-75" />
                                        <button type="button" class="absolute inset-0 focus:outline-none">
                                            <span class="sr-only">View details for {{ file.name }}</span>
                                        </button>
                                    </div>
                                    <p class="pointer-events-none mt-1.5 block truncate text-xs font-medium text-font-dark">{{ file.name }}</p>
                                </li>
                            </ul>
                            <media-select-multiple
                                :media="media"
                                :edit="gallery_images.length > 0"
                                :selected="gallery_images"
                                @update="updateGalleryImages"
                                :proposal="proposal"
                            />
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import MediaSelectMultiple from "@/Components/Media/MediaPickerMultiple.vue";
import {ref} from "vue";
import EditableProposalText from "@/ComponentsDeprecated/Proposal/EditableProposalText";

const editable = ref(false)

const props = defineProps({
    proposal: {
        type: Object,
        required: true
    },
    media: {
        type: Array,
        default: []
    },
    updateGalleryImages: {
        type: Function
    },
    gallery_images: {},
    loading_gallery_images: {},
    header_image: {},
    editMedia: {
        type: Function
    },
})

const intro = [
    {
        title: 'En overordnet og spennende overskrift for hele reisen',
        text: 'Her er det plass til litt mer mengdetekst for å kunne fylle inn mer info om hele reisen. Her er det plass til litt mer mengdetekst for å kunne fylle inn mer info om hele reisen. sdfsdfHer er det plass til litt mer mengdetekst',
        expand: 'Mengdeteksten skal komme frem når man trykker på les mer.'
    }
]


</script>
